export const Types = {
  REQUEST: '@produtos/REQUEST',
  SUCCESS: '@produtos/SUCCESS',
  FAILURE: '@produtos/FAILURE',
};

export function loadProdutosRequest() {
  return {
    type: Types.REQUEST,
  };
}

export function loadProdutosSuccess(produtos) {
  return {
    type: Types.SUCCESS,
    payload: produtos,
  };
}

export function loadProdutosFailure() {
  return {
    type: Types.FAILURE,
  };
}
